export const environment = {
    apiUrl:"https://test.api.skillproof.hu/api",
    apiUrls:{
        login:"https://test.api.skillproof.hu/api/User/Login",
        register:"https://test.api.skillproof.hu/api/User/Register",
        getProfile:"https://test.api.skillproof.hu/api/User",
        updateUser:"https://test.api.skillproof.hu/api/User",
        getProfileTests:"https://test.api.skillproof.hu/api/User/UserTests",
        getJobsOfCompany:"https://test.api.skillproof.hu/api/Jobs/jobsOfCompany",
        updateSkills:"https://test.api.skillproof.hu/api/User/UpdateSkills"
    }
};
